// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.junction-box-utilization-table[data-v-a39926b0] {\n    padding: 8px;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    flex: 1;\n}\n.header[data-v-a39926b0] {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.total-row td[data-v-a39926b0] {\n    background: #f0f4f8;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
